<footer class="fixed-bottom footer">
  <ng-container [ngTemplateOutlet]="childTemplate">
  </ng-container>
</footer>
